export const previewSidebar = {
  openPreviewSidebar: 'Open model preview',
  noModelAssigned: 'The option has no assigned model',
  noStepsInStage: 'No options assigned to the step!',
  noOptionInSteps: 'No steps assigned to the stage!',
  preview: 'Preview',
} as const
